import AttachableRiderHeaderTable from '../../second-step/riders/attachable-rider-header-table';
import AttachableRiderInputUniformCoverage from '../../second-step/riders/attachable-rider-input-uniform-coverage';
import AttachableRiderInputLevelRankingBySalaryRank from '../../second-step/riders/attachable-rider-input-level-ranking-by-salary-rank';
import { PROPOSAL_RIDERS } from '../../../../../../constant/gms-constant';
import { getProposalRidersByOrder } from '../../../../../../helper/proposal/proposal-riders';
import AttachableRiderInputAmountOfLoans from '../../second-step/riders/attachable-rider-input-amount-of-loans';
import AttachableRiderInputBMSR from '../../second-step/riders/attachable-rider-input-BMSR';
import { RiderGHIRandGAMERRandBB, SelectedRider } from '../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.state';
import { InputByLevelRanking, LevelRankingRider } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.state';
import { RowData, SalaryRankRider } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.state';
import { SubTypeOption } from '../../../../../../api/gms/group-category/group-category-api-state';
import { UniformCoverageRiderItem, UniformCoverageTypes } from '../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.state';
import { AmountOfLoansRider } from '../../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.state';

interface Props {
    isPreview?: boolean;
    isCustom?: boolean;
    isProductGCLI: boolean;
    isSalaryRank: boolean;
    isUniformCoverage: boolean;
    isLevelRankingAndSalaryRank: boolean;
    selectedRiders: SelectedRider[];
    inputsBySalaryRank: RowData[];
    inputsByLevelRanking: InputByLevelRanking[]

    selectedCoverageTypeState: SubTypeOption | null
    selectedAmountOfLoansCheckBox: SubTypeOption | null
    inputsByUniformCoverage: UniformCoverageTypes | null

    selectedBMSR: RiderGHIRandGAMERRandBB | null

    isAmountOfLoan: boolean;
    amountOfLoansRiders: AmountOfLoansRider[]

    selectUniformCoverageRidersState: UniformCoverageRiderItem[]

    selectLevelRankingRidersState: LevelRankingRider[] | undefined
    selectSalaryRankRidersState: SalaryRankRider[]
    isLevelRanking: boolean;
}

export default function SelectedAttachableRiderTable({ 
    inputsBySalaryRank, 
    inputsByLevelRanking, 
    selectedRiders, 
    isProductGCLI, 
    isSalaryRank, 
    isUniformCoverage, 
    isLevelRankingAndSalaryRank, 
    isPreview, 

    selectedCoverageTypeState,
    selectedAmountOfLoansCheckBox,
    inputsByUniformCoverage,

    selectedBMSR,

    isAmountOfLoan,
    amountOfLoansRiders,

    selectUniformCoverageRidersState,

    selectLevelRankingRidersState,
    selectSalaryRankRidersState,
    isLevelRanking,

    isCustom = false 
}: Props) {

    const inputLength = isSalaryRank ? inputsBySalaryRank.length : inputsByLevelRanking.length

    const ridersIdsOrder = [
        PROPOSAL_RIDERS.GTPDRC.productFor.GCLI,

        PROPOSAL_RIDERS.GADBR.productFor.GYRT,
        PROPOSAL_RIDERS.GADDR.productFor.GYRT,
        PROPOSAL_RIDERS.GADDR_PLUS.productFor.GYRT,
        PROPOSAL_RIDERS.GSADDR.productFor.GYRT,
        PROPOSAL_RIDERS.GTPDR.productFor.GYRT,
        PROPOSAL_RIDERS.GTIR.productFor.GYRT,
        PROPOSAL_RIDERS.GHIR.productFor.GYRT,
        PROPOSAL_RIDERS.GAMERR.productFor.GYRT,
        PROPOSAL_RIDERS.ALCR.productFor.GYRT,
        PROPOSAL_RIDERS.BMSR.productFor.GYRT,
        PROPOSAL_RIDERS.GMR.productFor.GYRT,
        PROPOSAL_RIDERS.GDR.productFor.GYRT,
        PROPOSAL_RIDERS.GMBDR.productFor.GYRT,
        PROPOSAL_RIDERS.GCIR5.productFor.GYRT,
        PROPOSAL_RIDERS.GCIR45.productFor.GYRT,

        PROPOSAL_RIDERS.GAMERR.productFor.GPA,
        PROPOSAL_RIDERS.GMR.productFor.GPA,
        PROPOSAL_RIDERS.GMBDR.productFor.GPA,
        PROPOSAL_RIDERS.GCIR5.productFor.GPA,
        PROPOSAL_RIDERS.GCIR45.productFor.GPA,

        PROPOSAL_RIDERS.GADBR.productFor.GCI,
        PROPOSAL_RIDERS.GADDR.productFor.GCI,
        PROPOSAL_RIDERS.GADDR_PLUS.productFor.GCI,
        PROPOSAL_RIDERS.GTPDR.productFor.GCI,
        PROPOSAL_RIDERS.GTIR.productFor.GCI,
        PROPOSAL_RIDERS.GHIR.productFor.GCI,
        PROPOSAL_RIDERS.GAMERR.productFor.GCI,
        PROPOSAL_RIDERS.ALCR.productFor.GCI,
        PROPOSAL_RIDERS.BMSR.productFor.GCI,
        PROPOSAL_RIDERS.GMR.productFor.GCI,
        PROPOSAL_RIDERS.GDR.productFor.GCI,
        PROPOSAL_RIDERS.GMBDR.productFor.GCI,
    ];
    const priorityRiderList = getProposalRidersByOrder(ridersIdsOrder)
    const priorityIds = priorityRiderList.map(item => item.id);

    // Sorting for table based on priorityIds
    const sortedRidersForTable = [...selectedRiders].sort((a, b) => {
        const aPriority = priorityIds.indexOf(a.id);
        const bPriority = priorityIds.indexOf(b.id);

        if (aPriority !== -1 && bPriority !== -1) {
            // both are in priority list → sort by the list order
            return aPriority - bPriority;
        } else if (aPriority !== -1) {
            // only a is in priority → a goes first
            return -1;
        } else if (bPriority !== -1) {
            // only b is in priority → b goes first
            return 1;
        } else {
            // neither in priority → sort by id ascending
            return a.id - b.id;
        }
    });

    return (
        <div className={`bg-white ${isPreview ? 'rounded-lg overflow-hidden border' : 'p-2 lg:p-3 rounded border border-gray-200'}`}>
            <div className='flex flex-col space-y-2'>
                <div className='w-full overflow-x-auto'>
                    <table className={`${isPreview ? '' : ''} w-full border rounded overflow-hidden border-gray-300 text-xs`}>
                    {isPreview && selectedRiders.length === 0 ? (
                        <div className='text-xs py-2 px-3 text-gray-600'>No rider selected.</div>
                    ) : (
                        <>
                            <AttachableRiderHeaderTable 
                                isBySalaryRank={isSalaryRank}
                                selectedCoverageTypeState={selectedCoverageTypeState}
                                selectedAmountOfLoansCheckBox={selectedAmountOfLoansCheckBox}
                                inputsByUniformCoverage={inputsByUniformCoverage}
                                inputsBySalaryRank={inputsBySalaryRank}
                                inputsByLevelRanking={inputsByLevelRanking}
                                isProductGCLI={isProductGCLI}
                            />
                            <tbody>
                                {sortedRidersForTable.map((rider) => {

                                    if (Object.values(PROPOSAL_RIDERS.BMSR.productFor).some((id) => id === rider.id)) {
                                        return (
                                            <AttachableRiderInputBMSR
                                                selectedBMSR={selectedBMSR}
                                                key={rider.id}
                                                riderLabel={rider.label}
                                                inputLength={inputLength}
                                                rider={rider}
                                                isPreview={isPreview}
                                            />
                                        );
                                    }

                                    if(isAmountOfLoan) {
                                        return (
                                            <AttachableRiderInputAmountOfLoans
                                                amountOfLoansRiders={amountOfLoansRiders}
                                                isAmountOfLoan={isAmountOfLoan}
                                                key={rider.id}
                                                rider={rider}
                                                riderLabel={rider.label}
                                                isPreview={isPreview}
                                            />
                                        )
                                    }
                                
                                    if (isUniformCoverage) {
                                        return (
                                            <AttachableRiderInputUniformCoverage
                                                selectUniformCoverageRidersState={selectUniformCoverageRidersState}
                                                selectedCoverageTypeState={selectedCoverageTypeState}
                                                key={rider.id}
                                                rider={rider}
                                                riderLabel={rider.label}
                                                isPreview={isPreview}
                                            />
                                        );
                                    }
                                
                                    if (isLevelRankingAndSalaryRank) {
                                        return (
                                            <AttachableRiderInputLevelRankingBySalaryRank
                                                selectLevelRankingRidersState={selectLevelRankingRidersState}
                                                selectSalaryRankRidersState={selectSalaryRankRidersState}
                                                isLevelRanking={isLevelRanking}
                                                isSalaryRank={isSalaryRank}
                                                key={rider.id}
                                                riderLabel={rider.label}
                                                rider={rider}
                                                isPreview={isPreview}
                                            />
                                        );
                                    }
                                    
                                    return null;
                                })}
                            </tbody>
                        </>
                    )}
                    </table>
                </div>
            </div>
        </div>
    )
}